var map = {
	"./arrow.svg": 3373,
	"./avatar.svg": 3670,
	"./background.svg": 1495,
	"./balance.svg": 878,
	"./cn.svg": 6748,
	"./en.svg": 4495,
	"./help.svg": 2437,
	"./kr.svg": 1266,
	"./language.svg": 3580,
	"./linking.svg": 1607,
	"./logout.svg": 4300,
	"./not-veryfy.svg": 7717,
	"./qr.svg": 1914,
	"./setting.svg": 6714,
	"./share.svg": 2782,
	"./verified.svg": 1978,
	"./vn.svg": 5725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4992;